import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { Watch } from "scrollmonitor-react";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        transition: "opacity 0.5s ease-in, transform 0.5s ease-in"
    }
});

interface FadeInProps {
    isBelowViewport?: boolean,
    isInViewport?: boolean,
    stopWatcher?: () => void,
    onVisible?: () => void
}

interface FadeInState {
    visible: boolean
}

class FadeIn extends React.Component<WithStyles<ClassNames> & FadeInProps, FadeInState> {

    public componentWillMount() {
        const {isInViewport, onVisible} = this.props;
        const visible = !!isInViewport;
        this.setState({ visible });
        if (visible && onVisible) {
            onVisible();
        }
    }

    public componentWillReceiveProps({isBelowViewport, isInViewport, onVisible}: FadeInProps) {
        const {visible} = this.state;
        if (!visible) {
            this.setState({ visible: !!isInViewport || !isBelowViewport });
            if ((!!isInViewport || !isBelowViewport) && onVisible) {
                 onVisible();
            }
        }
    }

    public render() {
        const {classes, children} = this.props;
        const {visible} = this.state;
        const opacity = visible ? 1 : 0;
        const transform = visible ? "translateY(0)" : "translateY(20px)";
        return (
            <div className={classes.container} style={{ opacity, transform }}>
                {children}
            </div>
        );
    }
}

const WatchedFadeIn = Watch(FadeIn);
export default withStyles(styles)<FadeInProps>((props: FadeInProps) => <WatchedFadeIn offsets={-100} {...props} />);



// WEBPACK FOOTER //
// ./src/components/FadeIn.tsx